import styles from "./styles.module.scss";
import LandingHeader from "component/Common/LandingHeader";
import LandingFooter from "component/Common/LandingFooter";

export const LandingLayout = (props) => {
  return (
    <div className="w-100-landing m-0">
      <LandingHeader />
      <div className={``}>
        <div className={styles.container}>{props.children}</div>
      </div>
      <LandingFooter />
    </div>
  );
};
